import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { VariantCategory } from "../../types/modules/variantCategory.type";

export const useVariantCategoriesByAdmin = () => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["variant-category-by-admin"],
    queryFn: () => fetcher<VariantCategory[]>(`variant-category/admin`, token),
  });
};
